// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fsl7","option":"styles_option__2vKRY","active":"styles_active__2RQxj"};